import React from 'react'
import { Button, OverlayTrigger, Tooltip } from 'react-bootstrap'
import Swal from 'sweetalert2'
import withReactContent from 'sweetalert2-react-content'
import { connect } from 'react-redux'
import { handleExpiredAuthState } from '../../../redux/actions/authActions'
import { deleteFromList } from '../../../redux/actions/periodActions'
import PeriodsApi from '../../../api/PeriodsApi'
import { ApiException, ExpiredSessionException } from '../../../api/exceptions'

const DeleteButton = ({ slug, nombre, deleteFromList, handleExpiredAuthState }) => {
  
  const alert = withReactContent(Swal)

  const handleClick = () => {

    /** Trigger dialog */
    alert.fire({
      title: `¿Desea borrar el periodo ${nombre}?`,
      icon: 'warning',
      confirmButtonText: 'Si',
      showCancelButton: true,
      cancelButtonText: 'Cancelar',
      showLoaderOnConfirm: true,
      preConfirm: (response) => {

        if (response) {
          const api = new PeriodsApi();

          api.delete(slug)
            .then( 
            
              () => {
                deleteFromList(slug)
                alert.fire({
                  title: 'Exito',
                  text: 'El periodo fue eliminado correctamente',
                  icon: 'success'
                })
              },

              error => {
                let message = 'Hubo un error al procesar la solicitud. Intente más tarde.';

                if (error instanceof ExpiredSessionException) {
                  return handleExpiredAuthState();
                } else if (error instanceof ApiException) {
                  message = error.message;
                }

                alert.fire({
                  title: 'Error',
                  text: message,
                  icon: 'error'
                })
              }

          )
        }
      }
    })
  }

  return (
    <OverlayTrigger
      overlay={
        <Tooltip>
         <strong>Eliminar</strong>
        </Tooltip>
      }
    >
      <Button onClick={() => handleClick()} variant='danger' className='mr-1'>
          <span className="fa fa-fw fa-trash"></span>
      </Button>
    </OverlayTrigger>
    
  )
}

export default connect(null, { handleExpiredAuthState, deleteFromList })(DeleteButton)